import "sanitize.css";

import "./index.scss";

import "components/scripts";

import { lazyLoadService } from "services";

// init lazy load script
lazyLoadService.observe();
